import * as React from 'react'
import { Button } from '@/ui/button'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { FullLogo } from '@/app/features/icons/FullLogo'

const NotFound = () => {
  const { t } = useLocalize()

  return (
    <div className="error-page-wrapper">
      <FullLogo className="tw-mt-8 tw-h-8" />
      <h1>404</h1>
      <p>
        {t('exception.not-found')}
      </p>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          window.location.href = window.location.origin
        }}
      >
        {t('globalSettings.go_back')}
      </Button>
    </div>
  )
}

export default NotFound
